import { AeoPromptTopicSchema } from "@redotech/redo-model/aeo/prompt";
import * as z from "zod";

export const setAeoPromptTopics = {
  name: "setAeoPromptTopics" as const,
  input: z.object({ promptId: z.bigint(), topicIds: z.array(z.bigint()) }),
  output: z.object({ topics: z.array(AeoPromptTopicSchema) }),
};
